"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setComponentToBeEdited = exports.closeEditComponentModal = exports.openEditComponentModal = exports.closeComponentToast = exports.openComponentToast = exports.closeComponentModal = exports.openComponentModal = exports.deleteComponentError = exports.deleteComponentSuccess = exports.deleteComponent = exports.saveChangesError = exports.saveChangesSuccess = exports.saveChanges = exports.onHideSavePrompt = exports.onShowSavePrompt = exports.openDeleteComponentAlert = exports.closeDeleteComponentAlert = exports.getComponentsListError = exports.getComponentsListSuccess = exports.getComponentsList = exports.componentsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    components: [],
    isComponentListLoading: false,
    hasErrorLoadingComponents: false,
    isDeleteAlertDialogOpen: false,
    componentToBeDeleted: null,
    rowIndexToBeDeleted: 0,
    isSavePromptVisible: false,
    isSavingChanges: false,
    hasErrorSavingChanges: false,
    changesSavedSuccess: false,
    isDeleting: false,
    hasDeletionError: false,
    isComponentModalVisible: false,
    isComponentToastOpen: false,
    componentToBeEdited: null,
    isEditComponentModalVisible: false,
    errorMessage: "",
};
exports.componentsSlice = (0, toolkit_1.createSlice)({
    name: "components",
    initialState,
    reducers: {
        getComponentsList: (state) => {
            state.isComponentListLoading = true;
        },
        getComponentsListSuccess: (state, action) => {
            state.isComponentListLoading = false;
            state.hasErrorLoadingComponents = false;
            state.components = action.payload;
        },
        getComponentsListError: (state) => {
            state.isComponentListLoading = false;
            state.hasErrorLoadingComponents = true;
        },
        openDeleteComponentAlert: (state, action) => {
            state.isDeleteAlertDialogOpen = true;
            state.componentToBeDeleted = action.payload.componentToBeDeleted;
            state.rowIndexToBeDeleted = action.payload.rowIndexToBeDeleted;
        },
        closeDeleteComponentAlert: (state) => {
            state.isDeleteAlertDialogOpen = false;
            state.componentToBeDeleted = null;
            state.rowIndexToBeDeleted = 0;
            state.errorMessage = "";
        },
        onShowSavePrompt: (state) => {
            state.isSavePromptVisible = true;
        },
        onHideSavePrompt: (state) => {
            state.isSavePromptVisible = false;
        },
        saveChanges: (state) => {
            state.isSavingChanges = true;
        },
        saveChangesSuccess: (state) => {
            state.isSavingChanges = false;
            state.changesSavedSuccess = true;
            state.hasErrorSavingChanges = false;
        },
        saveChangesError: (state) => {
            state.changesSavedSuccess = false;
            state.hasErrorSavingChanges = true;
            state.isSavingChanges = false;
        },
        deleteComponent: (state) => {
            state.isDeleting = true;
        },
        deleteComponentSuccess: (state) => {
            state.isDeleting = false;
            state.isDeleteAlertDialogOpen = false;
            state.componentToBeDeleted = null;
            state.rowIndexToBeDeleted = 0;
            state.hasDeletionError = false;
            state.errorMessage = "";
        },
        deleteComponentError: (state, action) => {
            state.isDeleting = false;
            state.hasDeletionError = true;
            state.errorMessage = action.payload;
        },
        openComponentModal: (state) => {
            state.isComponentModalVisible = true;
        },
        closeComponentModal: (state) => {
            state.isComponentModalVisible = false;
        },
        openEditComponentModal: (state) => {
            state.isEditComponentModalVisible = true;
        },
        closeEditComponentModal: (state) => {
            state.isEditComponentModalVisible = false;
        },
        openComponentToast: (state) => {
            state.isComponentToastOpen = true;
        },
        closeComponentToast: (state) => {
            state.isComponentToastOpen = false;
        },
        setComponentToBeEdited: (state, action) => {
            state.componentToBeEdited = action.payload;
        },
    },
});
_a = exports.componentsSlice.actions, exports.getComponentsList = _a.getComponentsList, exports.getComponentsListSuccess = _a.getComponentsListSuccess, exports.getComponentsListError = _a.getComponentsListError, exports.closeDeleteComponentAlert = _a.closeDeleteComponentAlert, exports.openDeleteComponentAlert = _a.openDeleteComponentAlert, exports.onShowSavePrompt = _a.onShowSavePrompt, exports.onHideSavePrompt = _a.onHideSavePrompt, exports.saveChanges = _a.saveChanges, exports.saveChangesSuccess = _a.saveChangesSuccess, exports.saveChangesError = _a.saveChangesError, exports.deleteComponent = _a.deleteComponent, exports.deleteComponentSuccess = _a.deleteComponentSuccess, exports.deleteComponentError = _a.deleteComponentError, exports.openComponentModal = _a.openComponentModal, exports.closeComponentModal = _a.closeComponentModal, exports.openComponentToast = _a.openComponentToast, exports.closeComponentToast = _a.closeComponentToast, exports.openEditComponentModal = _a.openEditComponentModal, exports.closeEditComponentModal = _a.closeEditComponentModal, exports.setComponentToBeEdited = _a.setComponentToBeEdited;
exports.default = exports.componentsSlice.reducer;
